import { ErrorElement, ToastProvider } from '@components';
import { PathnameEnum } from '@constant';
import {
  ActionGenreOutputPage,
  BodyPartOutputPage,
  EtcOutputPage,
  FacialExpressionOutputPage,
  MainPage,
  AdultsOnlyOutputPage,
  StandardOutputPage,
  LoginPage,
  UsedImageListPage,
  ImageUploaderImageListPage,
  ImageUploaderImageUploadPage,
  CollectionListPage,
  CollectionImageListPage
} from '@pages';
import { useSelector } from '@stores';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';

// 로그인하지 않은 사용자의 접근을 제한하고 로그인 페이지로 리디렉트
const PublicRoute = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path={PathnameEnum.LOGIN_PAGE} element={<LoginPage />} />
      {/* 원래 가려던 페이지를 state에 저장하여 로그인 후 해당 페이지로 이동하도록 설정 */}
      <Route path="*" element={<Navigate to={PathnameEnum.LOGIN_PAGE} replace state={{ from: location }} />} />
    </Routes>
  );
};

// 로그인한 사용자만 접근 가능한 페이지
const RestrictRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={PathnameEnum.MAIN_PAGE} replace />} />
      <Route path={PathnameEnum.MAIN_PAGE} element={<MainPage />} />
      <Route path={PathnameEnum.LOGIN_PAGE} element={<Navigate to={PathnameEnum.MAIN_PAGE} replace />} />

      {/* 검색 결과 페이지 */}
      <Route path={PathnameEnum.STANDARD_OUTPUT_PAGE} element={<StandardOutputPage />} />
      <Route path={PathnameEnum.ADULTS_ONLY_OUTPUT_PAGE} element={<AdultsOnlyOutputPage />} />
      <Route path={PathnameEnum.ACTION_GENRE_OUTPUT_PAGE} element={<ActionGenreOutputPage />} />
      <Route path={PathnameEnum.BODY_PART_OUTPUT_PAGE} element={<BodyPartOutputPage />} />
      <Route path={PathnameEnum.FACIAL_EXPRESSION_OUTPUT_PAGE} element={<FacialExpressionOutputPage />} />
      <Route path={PathnameEnum.ETC_OUTPUT_PAGE} element={<EtcOutputPage />} />

      {/* 컬렉션 관련 페이지 */}
      <Route path={PathnameEnum.COLLECTION_LIST_PAGE} element={<CollectionListPage />} />
      <Route path={PathnameEnum.USED_IMAGE_LIST_PAGE} element={<UsedImageListPage />} />
      <Route path={PathnameEnum.COLLECTION_IMAGE_LIST_PAGE} element={<CollectionImageListPage />} />

      {/* 이미지 업로더 관련 페이지 */}
      <Route path={PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_LIST_PAGE} element={<ImageUploaderImageListPage />} />
      <Route
        path={PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_UPLOAD_PAGE}
        element={<ImageUploaderImageUploadPage />}
      />
      <Route
        path={PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_EDIT_PAGE}
        element={<ImageUploaderImageUploadPage />}
      />

      <Route path="*" element={<ErrorElement />} />
    </Routes>
  );
};

// 로그인 상태를 확인하고, 원래 가려던 페이지로 이동시키는 컴포넌트
const AppRoutes = () => {
  const isLogin = useSelector((state) => state.auth.isLogin);

  // 로그인 후 이동할 경로 설정 (원래 가려던 경로가 있으면 해당 경로로 이동)
  const location = useLocation();
  const redirectPath = location.state?.from?.pathname;

  if (!isLogin) {
    return <PublicRoute />;
  }

  // RestrictRoute를 먼저 렌더링하여 정상적으로 페이지가 보이도록 처리
  return (
    <>
      <RestrictRoute />
      {redirectPath && <Navigate to={redirectPath} replace />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
